<script>
import BundleItem from '@school/components/BundleItem.vue';

export default {
  components: { BundleItem },
  props: {
    total: {
      type: Number,
      required: true,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    hasTitle: {
      type: Boolean,
      default: true,
    },
    hasPrice: {
      type: Boolean,
      default: true,
    },
    bundles: {
      type: Array,
      required: true,
    },
  },
  i18n: {
    messages: {
      en: {
        bundles_title: 'Bundles',
        no_bundles_yet: 'There are no packs yet!',
        no_bundles_match_search: 'No packs match your search.',
      },
      fr: {
        bundles_title: 'Packs',
        no_bundles_yet: 'Il n\'y a pas encore de packs !',
        no_bundles_match_search: 'Aucun pack ne correspond à votre recherche.',
      },
    },
  },
};
</script>

<template>
  <section>
    <h2 v-if="hasTitle" class="title is-custom is-size-5-touch">
      {{ $t('bundles_title') }}
    </h2>

    <p v-if="total <= 0" class="box">
      {{ $t('no_bundles_yet') }}
    </p>
    <template v-else-if="bundles.length">
      <BundleItem v-for="bundle in bundles" :key="bundle.uuid" v-bind="{ bundle, hasPrice }"
        :class="{ 'is-small': isSmall }" />
    </template>
    <p v-else class="box">
      {{ $t('no_bundles_match_search') }}
    </p>
  </section>
</template>
